import { Box, Grid, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { ThemedAsset, assetIds } from "nemuru-components";
import Text from "../../../../shared/components/Text";

export const VideoIdSuccessMessage = () => {
  const { palette } = useTheme();
  return (
    <>
      <Box
        mt={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className="appear-anim"
      >
        <ThemedAsset
          id={assetIds.ICON_SUCCESS}
          width={50}
          height={50}
          style={{ color: palette.success.main }}
        />
        <Grid
          container
          display="flex"
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: 20 }}
        >
          <Typography
            color={palette.text.title}
            variant={"h6"}
            className={"mb-4 transition-all"}
          >
            <strong>
              <Text tId={"WELL_DONE"} />
            </strong>
          </Typography>
          <Typography
            variant={"body2"}
            className={"mb-3 transition-all"}
            style={{
              color: palette.text.primary,
              textAlign: "center",
            }}
          >
            <Text tId={"YOUR_VIDEO_ID_HAS_BEEN_SUCCESSFULLY_RECORDED"} />
          </Typography>
          <Typography
            variant={"body2"}
            className={"mb-3 transition-all"}
            style={{
              color: palette.text.primary,
              textAlign: "center",
            }}
          >
            <Text tId={"YOU_CAN_SAFELY_CLOSE_THIS_TAB"} />
          </Typography>
        </Grid>
      </Box>
      <Box />
    </>
  );
};
